/**
 * Resolve the Applications menu href from the page the user is currently on.
 * Any saved financing or borrower application counts as having applications.
 */
export function getApplicationsMenuHref(
  pathname,
  { hasDeviceFinancingApplications, hasBorrowerApplications }
) {
  const hasAnyApplications =
    !!hasDeviceFinancingApplications || !!hasBorrowerApplications;

  if (pathname.startsWith('/us/financing')) {
    return hasAnyApplications ? '/applications' : '/us/financing';
  }

  if (pathname.startsWith('/financing')) {
    return hasAnyApplications ? '/applications' : '/financing';
  }

  if (
    pathname === '/' ||
    pathname === '/applications' ||
    pathname.startsWith('/applications/')
  ) {
    return hasAnyApplications ? '/applications' : '/applications/apply';
  }

  return '/applications';
}

/**
 * When the applications dashboard is empty, choose a default apply path from
 * the incoming referer (no cookies).
 */
export function getEmptyApplicationsRedirectPath(referer) {
  if (!referer) {
    return '/applications/apply';
  }

  try {
    const pathname = new URL(referer).pathname;
    if (pathname.startsWith('/us/financing')) {
      return '/us/financing';
    }
    if (pathname.startsWith('/financing')) {
      return '/financing';
    }
  } catch {
    /* ignore */
  }

  return '/applications/apply';
}
